import { useContext } from 'react';
import { MessageContext } from '../../context/MesssageContext';

const useMessage = () => useContext(MessageContext);

export default useMessage;
